import React from 'react';
import useAsync from 'react-use/esm/useAsync';
import { Table, Progress, ResponseErrorPanel } from '@backstage/core-components';

type User = {
  id: number;
  name: string;
  username: string;
  email: string;
  phone: string;
  website: string;
  address: {
    city: string;
  };
  company: {
    name: string;
  };
};

export const UsersTable = () => {
  const { value, loading, error } = useAsync<User[]>(async () => {
    const response = await fetch('https://jsonplaceholder.typicode.com/users');

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }

    return response.json();
  }, []);

  if (loading) {
    return <Progress />;
  }

  if (error) {
    return <ResponseErrorPanel error={error} />;
  }

  return (
    <Table
      title="Users from JSONPlaceholder"
      options={{
        paging: true,
        search: true,
        sorting: true,
      }}
      columns={[
        { title: 'ID', field: 'id' },
        { title: 'Name', field: 'name' },
        { title: 'Username', field: 'username' },
        { title: 'Email', field: 'email' },
        {
          title: 'City',
          render: row => row.address.city,
        },
        { title: 'Phone', field: 'phone' },
        {
          title: 'Company',
          render: row => row.company.name,
        },
        { title: 'Website', field: 'website' },
      ]}
      data={value ?? []}
    />
  );
};

